import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import PravnoLiceCard from "../components/PravnoLiceCard";
import SaradnjaPonudePravnoLice from "../components/SaradnjaPonudePravnoLice";
import HistorijaSaradnje from "../components/SaradnjaPonudeFizickoLice";
import "./LoginFizickogLicaUspio.scss";
import Head from "../modules/Head";
import HeaderComponent from "../components/HeaderComponent";
import axios from "axios";
import Cookies from "universal-cookie";
import config from "../config.json";

function LoginFizickogLica() {
  const { baseUrl, token } = config;
  const [poslovi, setPoslovi] = useState([]);
  const [ponude, setPonude] = useState([]);
  const [historija, setHistorija] = useState([]);
  const [error, setError] = useState(null);
  const cookies = new Cookies();
  const user = cookies.get("fizickoLice");

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await axios.get(`${baseUrl}/fizicko/ponude-poslova`, {
          headers: {
            token: token,
            "Content-Type": "application/json",
          },
        });

        const response2 = await axios.get(
          `${baseUrl}/fizicko/pristigle-ponude/${user.korisnickoIme}`,
          {
            headers: {
              token: token,
              "Content-Type": "application/json",
            },
          }
        );

        const response3 = await axios.get(
          `${baseUrl}/fizicko/historija-saradnji/${user.korisnickoIme}`,
          {
            headers: {
              token: token,
              "Content-Type": "application/json",
            },
          }
        );

        setPoslovi(response.data);
        setPonude(response2.data);
        setHistorija(response3.data.slice().reverse());
        setError(null);
      } catch (error) {
        setError("Greška u prenosu podataka sa servera.");
      }
    }

    fetchData();

    const checkInterval = setInterval(fetchData, 10000);
    return () => clearInterval(checkInterval);
  }, []);

  return (
    <>
      <Head title="Login Fizickog Lica" />
      <Container fluid="md">
        <HeaderComponent />
        <Row>
          {error && (
            <Col>
              <p className="error-p">{error}</p>
            </Col>
          )}
          {!error && (
            <>
              <Col md={6} className="pravna-lica-usluge">
                <h2>Pregled pravnih lica i usluga </h2>
                <Row>
                  {poslovi.length === 0 ? (
                    <Col>
                      <p className="error-p">Za sada nema posla.</p>
                    </Col>
                  ) : (
                    <Col md={6} className="client-cards-left">
                      {poslovi.map((posao, index) => {
                        if (index % 2 === 0) {
                          return (
                            <PravnoLiceCard
                              key={index}
                              naziv={posao.ime}
                              kontakt={posao.djelatnost}
                              sjediste={posao.sjediste}
                              djelatnost={posao.djelatnost}
                              slika={posao.logotip}
                              korisnickoIme={posao.korisnickoIme}
                            />
                          );
                        }
                        return null;
                      })}
                    </Col>
                  )}
                  <Col md={6} className="client-cards-right">
                    {poslovi.map((posao, index) => {
                      if (index % 2 !== 0) {
                        return (
                          <PravnoLiceCard
                            key={index}
                            naziv={posao.ime}
                            kontakt={posao.djelatnost}
                            sjediste={posao.sjediste}
                            djelatnost={posao.djelatnost}
                            slika={posao.logotip}
                            korisnickoIme={posao.korisnickoIme}
                          />
                        );
                      }
                      return null;
                    })}
                  </Col>
                </Row>
              </Col>
              <Col md={3} className="historija-saradnje-fizickog-lica">
                <h2>Historija saradnje</h2>
                <Row className="saradnja-ponude-container">
                  {historija.length === 0 ? (
                    <Col>
                      <p className="error-p">Nemate historije.</p>
                    </Col>
                  ) : (
                    <Col>
                      {historija.map((povijest, index) => {
                        return (
                          <HistorijaSaradnje
                            naziv={povijest.imePravnogLica}
                            kontakt={povijest.telefon}
                            cijena={povijest.cijena}
                            datum={povijest.date}
                            key={index}
                          />
                        );
                      })}
                    </Col>
                  )}
                </Row>
              </Col>
              <Col md={3} className="pregled-ponuda-fizickog-lica">
                <h2>Pristigle ponude</h2>
                <Row className="saradnja-ponude-container">
                  {ponude.length === 0 ? (
                    <Col>
                      <p className="error-p">Nemate ponuda.</p>
                    </Col>
                  ) : (
                    <Col>
                      {ponude.map((ponuda, index) => {
                        return (
                          <SaradnjaPonudePravnoLice
                            key={index}
                            naziv={ponuda.imePravnogLica}
                            kontakt={ponuda.telefon}
                            cijena={ponuda.cijena}
                            datum={ponuda.date}
                            id={index.toString()}
                          />
                        );
                      })}
                    </Col>
                  )}
                </Row>
              </Col>
            </>
          )}
        </Row>
      </Container>
    </>
  );
}

export default LoginFizickogLica;
